import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';

class UnauthorizedPlatinum extends Component{ 
    
    render(){
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,8,8,8]} offsetSize={[0,2,2,2]} style={{"textAlign":"center"}}>
                        <GridRow className = "padding-3 font">
                            <GridColumn>
                                <span>If you are interested in gaining the {this.props.formName} specialization, please contact your Adobe Business Manager.</span>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}
export default UnauthorizedPlatinum;
